<template>
  <div>
    <div class="flex flex-col items-center">
      <div class="flex items-center justify-center space-x-4 w-1/2">
        <v-text-field
          label="Search for contract numbers in tickets"
          prepend-inner-icon="mdi-magnify"
          clearable
          v-model="old_contract_number"
        ></v-text-field>
        <v-btn @click="getContractNumbersFromTickets(old_contract_number)"
          >Enter to Search</v-btn
        >
      </div>
    </div>
    <div
      v-if="ticket_numbers.length > 0"
      class="border-solid border-4 border-gray-800 p-4"
    >
      <div class="font-bold text-2xl text-center">
        Enter the new contract number
      </div>
      <div class="flex items-center justify-start space-x-4">
        <v-text-field
          label="Type the new contract number here..."
          v-model="new_contract_number"
        ></v-text-field>
        <v-btn @click="openReplaceContractNumberDialog" color="primary"
          >Enter to replace contract number</v-btn
        >
      </div>
      <v-data-table
        :headers="headers"
        :items="ticket_numbers"
        :loading="loading"
      >
        <template v-slot:[`item.reg_date`]="{ item }">
          {{ formatDate(item.reg_date) }}
        </template>
      </v-data-table>
      <v-dialog
        v-model="dialog"
        persistent
        :overlay="false"
        max-width="500px"
        transition="dialog-transition"
      >
        <div class="bg-white p-10">
          <div class="flex justify-end">
            <v-btn @click="cancel">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <div class="text-2xl font-bold">
            Are you certain you want to replace the contract number?
          </div>
          <div class="flex items-center justify-center space-x-4">
            <v-btn class="w-1/2" @click="cancel">Cancel</v-btn>
            <v-btn class="w-1/2" @click="go">GO</v-btn>
          </div>
        </div>
      </v-dialog>
    </div>
    <v-snackbar top v-model="snackbar">
      {{ snackbarText }}
      <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      snackbar: false,
      snackbarText: "",
      dialog: false,
      ticket_numbers: [],
      old_contract_number: "",
      new_contract_number: "",
      loading: false,
      headers: [
        {
          text: "Ticket Number",
          value: "moldex_ticket_number",
        },
        {
          text: "Contract Number",
          value: "contract_number",
        },
        {
          text: "Customer Code",
          value: "customer_code",
        },
        {
          text: "Buyer's Name",
          value: "buyer_name",
        },
        {
          text: "Ticket Date",
          value: "reg_date",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    openReplaceContractNumberDialog() {
      if (this.new_contract_number) {
        this.dialog = true;
      } else {
        this.snackbar = true;
        this.snackbarText = "Please fill out the new contract number field.";
      }
    },
    cancel() {
      this.dialog = false;
    },
    go() {
      this.dialog = false;
      const info = {
        new_contract_number: this.new_contract_number,
        old_contract_number: this.old_contract_number,
      };
      axios.post("/tickets/replace-contractnumbers", info).then((res) => {
        if (res.data.status) {
          this.ticket_numbers = [];
          this.snackbar = true;
          this.snackbarText = `Successfully updated ticket`;
          this.old_contract_number = "";
          this.new_contract_number = "";
        } else {
          alert("Something went wrong. Try again");
        }
      });
    },
    formatDate() {
      return moment().format("LL");
    },
    // 10000000820
    getContractNumbersFromTickets(entered_contract_number) {
      if (!this.old_contract_number) {
        this.snackbar = true;
        this.snackbarText = "Please fill out the search field.";
      } else {
        this.ticket_numbers = [];
        this.loading = true;
        const info = {
          old_contract_number: entered_contract_number,
        };
        axios.post("/tickets/contractnumbers", info).then((res) => {
          if (res.data.length > 0) {
            this.ticket_numbers = res.data;
            this.loading = false;
          } else {
            this.snackbar = true;
            this.snackbarText = "No data found.";
          }
        });
      }
    },
  },
};
</script>
